module.exports = __webpack_public_path__ + "static/img/1.4592d43.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2022ac/03/1.jpg
// module id = klR9
// module chunks = 0